import React from "react";
import { useDispatch } from "react-redux";
import { LOGOWHITE, PImage, FOODBG, INSTA, WHATSAPP, EMAIL, TWITTER, FACEBOOK} from "../images/images";
import { userActions } from "../../redux/actions";

export default function ContactUs() {

  const dispatch = useDispatch();
  let user = JSON.parse(localStorage.getItem("user"));

  function logout() {
    dispatch(userActions.logout());
  }

  return (
    <>
      <div
        className="main-header px-4"
        style={{
          backgroundImage: `url(${FOODBG})`,
          backgroundColor: "#ba2312",
        }}>
        <div className="logo">
          <a href="/">
            <img src={LOGOWHITE} alt="Logo" />
          </a>
        </div>

        <div style={{ margin: "auto" }} />
        <div className="header-part-right">
          {user?.data ? (
            <div className="dropdown">
              <div className="user col align-self-end">
                <div className="d-flex">
                  <p className="text-white mb-1 mr-3 text-capitalize">
                    Hello {user?.data?.name}
                  </p>
                  <div className="availability-status">
                    <img
                      src={PImage}
                      alt="avatar"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    />
                    <div
                      className="dropdown-menu dropdown-menu-right"
                      aria-labelledby="userDropdown">
                      <div className="dropdown-header">
                        <i className="i-Lock-User mr-1" /> {user?.data?.name}
                      </div>
                      <a className="dropdown-item" href="/user/profile">
                        My Profile
                      </a>
                      <button
                        className="dropdown-item"
                        onClick={() => logout()}>
                        Sign out
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <a
              href="/auth/login"
              className="btn btn-rounded btn-secondary btn-block">
              Login
            </a>
          )}
        </div>
      </div>
      <div className="main-content-padding">
        <div className="main-content">
          <div className="breadcrumb">
            <div>
              <h1 className="mr-2 mb-2">Contact Us</h1>
            </div>
          </div>
          <div className="separator-breadcrumb border-top" />
            <div data-test="contact-us-page">
              <div className="py-16 max-w-6xl px-6 mx-auto bg-white dark:bg-[#010101] relative -top-96 sm:-top-72">
                <main className="py-8">
                  <div className="max-w-6xl mx-auto lg:max-w-7xl">
                    <div className="sm:mt-8 justify-center items-center mx-auto">
                      <div style={{display:'flex', flexDirection:'column', justifyContent:'space-between' }}>
                        <a
                          href="tel:+2348140019523"
                          className="text-base text-start text-[#2b3674]">
                          <div className="flex items-center py-3 bg-white dark:bg-[#121212] px-5 sm:px-10 cursor-pointer shadow-lg rounded-lg h-[91px] sm:py-4 mb-6">
                            <div style={{display:'flex', paddingBottom:'10px', paddingTop:'10px'}}>
                              <img src={EMAIL} alt="email" />
                              <div className="ml-5">
                                <span className="dark:text-[#9CA3AF]">
                                  Customer Service
                                </span>
                              </div>
                            </div>
                          </div>
                        </a>
                        <a
                          href=" https://wa.me/message/FSYIRWHUMOYEJ1"
                          target={"_blank"}
                          className="text-base text-start text-[#2b3674]">
                          <div className="flex items-center py-3 bg-white dark:bg-[#121212] px-5 sm:px-10 shadow-lg rounded-lg h-[91px] sm:py-4 mb-6">
                            <div className="flex items-center justify-between ">
                              <div style={{display:'flex', paddingBottom:'10px', paddingTop:'10px'}}>
                                <img src={WHATSAPP} alt="Whatsapp" />
                                <div className="ml-5 ">
                                  <span className="dark:text-[#9CA3AF]">Whatsapp</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </a>
                        <a
                          href="https://web.facebook.com/ogwugofood/?_rdc=1&_rdr"
                          target="_blank"
                          rel="noopener noreferrer"
                          title="facebook"
                          className="text-base text-start text-[#2b3674]"
                        >
                          <div className="flex items-center py-3 bg-white dark:bg-[#121212] px-5 sm:px-10 shadow-lg rounded-lg h-[91px] sm:py-4 mb-6">
                            <div style={{display:'flex', paddingBottom:'10px', paddingTop:'10px'}}>
                              <img src={FACEBOOK} alt="phone" />
                              <div className="ml-5 ">
                                <span className="dark:text-[#9CA3AF]">Facebook</span>
                              </div>
                            </div>
                          </div>
                        </a>
                        <a
                          href="https://twitter.com/ogwugofood?lang=en"
                          target={"_blank"}
                          className="text-base text-start text-[#2b3674]"
                          title="twitter"
                          rel="noopener noreferrer"
                        >
                          <div className="flex items-center py-3 bg-white dark:bg-[#121212] px-5 sm:px-10 shadow-lg rounded-lg h-[91px] sm:py-4 mb-6">
                            <div style={{display:'flex', paddingBottom:'10px', paddingTop:'10px'}}>
                              <img src={TWITTER} alt="phone" />
                              <div className="ml-5 ">
                                <span className="dark:text-[#9CA3AF]">Twitter</span>
                              </div>
                            </div>
                          </div>
                        </a>
                        <a
                          href="https://www.instagram.com/ogwugofood/?hl=en"
                          target="_blank"
                          title="instagram"
                          rel="noopener noreferrer"
                          className="text-base text-start text-[#2b3674]"
                        >
                          <div className="flex items-center py-3 bg-white dark:bg-[#121212] px-5 sm:px-10 shadow-lg rounded-lg h-[91px] sm:py-4 mb-6">
                            <div style={{display:'flex', paddingBottom:'10px', paddingTop:'10px'}}>
                              <img src={INSTA} alt="Instagram" />
                              <div className="ml-5 text-left ">
                                <span className="dark:text-[#9CA3AF]">Instagram</span>
                              </div>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </main>
              </div>
            </div>
          </div>
      </div>
    </>
  );
}
